import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-selection",
  "use": "icon-selection-usage",
  "viewBox": "0 0 1502 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1502 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-selection\"><defs><style></style></defs><path d=\"M507.085 916.65L48.265 457.83 0 506.095l458.82 458.82-.512.512 48.265 48.265 965.461-965.427L1423.735 0l-916.65 916.65z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol